import {
    BaseTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/base-transition-model';
import { TransitionTarget, TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import { IAnimationSetting, IPushTransition } from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import { TransitionConfig } from '@src/slide/domain/ui-model/element-modeles/transition/config';
import { SideDirection } from '@src/slide/domain/ui-model/element-modeles/transition/direction/side-direction';
import { SideDirectionType } from '@src/slide/domain/ui-model/element-modeles/transition/direction/constants';

export class PushTransitionModel extends BaseTransitionModel<IPushTransition> implements IPushTransition {
    public type = TransitionType.PUSH;
    public direction: SideDirection;

    public getAnimationSetting(isSwitchForward?: boolean): IAnimationSetting[] {
        const direction = this.direction.getDirectionType(isSwitchForward);
        if (direction === SideDirectionType.UP) {
            return [{
                fromStyle: TransitionConfig.TRANSLATE_SHOW,
                toStyle: {
                    ...TransitionConfig.TRANSLATE_VERTICAL_NEGATIVE_HIDE,
                    ease: 'power1.inOut',
                },
                target: TransitionTarget.EXIT,
            }, {
                fromStyle: TransitionConfig.TRANSLATE_VERTICAL_POSITIVE_HIDE,
                toStyle: {
                    ...TransitionConfig.TRANSLATE_SHOW,
                    ease: 'power1.inOut',
                },
                target: TransitionTarget.ENTER,
            }];
        }
        if (direction === SideDirectionType.LEFT) {
            return [{
                fromStyle: TransitionConfig.TRANSLATE_SHOW,
                toStyle: {
                    ...TransitionConfig.TRANSLATE_HORIZONTAL_NEGATIVE_HIDE,
                    ease: 'power1.inOut',
                },
                target: TransitionTarget.EXIT,
            }, {
                fromStyle: TransitionConfig.TRANSLATE_HORIZONTAL_POSITIVE_HIDE,
                toStyle: {
                    ...TransitionConfig.TRANSLATE_SHOW,
                    ease: 'power1.inOut',
                },
                target: TransitionTarget.ENTER,
            }];
        }
        if (direction === SideDirectionType.DOWN) {
            return [{
                fromStyle: TransitionConfig.TRANSLATE_SHOW,
                toStyle: {
                    ...TransitionConfig.TRANSLATE_VERTICAL_POSITIVE_HIDE,
                    ease: 'power1.inOut',
                },
                target: TransitionTarget.EXIT,
            }, {
                fromStyle: TransitionConfig.TRANSLATE_VERTICAL_NEGATIVE_HIDE,
                toStyle: {
                    ...TransitionConfig.TRANSLATE_SHOW,
                    ease: 'power1.inOut',
                },
                target: TransitionTarget.ENTER,
            }];
        }
        return [{
            fromStyle: TransitionConfig.TRANSLATE_SHOW,
            toStyle: {
                ...TransitionConfig.TRANSLATE_HORIZONTAL_POSITIVE_HIDE,
                ease: 'power1.inOut',
            },
            target: TransitionTarget.EXIT,
        }, {
            fromStyle: TransitionConfig.TRANSLATE_HORIZONTAL_NEGATIVE_HIDE,
            toStyle: {
                ...TransitionConfig.TRANSLATE_SHOW,
                ease: 'power1.inOut',
            },
            target: TransitionTarget.ENTER,
        }];
    }
}
